import createIcon from '../../createIcon';

/**
 * @component @name ConnectingAirports
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNCAxNi45OTk2TDE2LjcgMjEuMzk5NkgxNS42TDEzIDE2Ljk5OTZIMTBDOS40NSAxNi45OTk2IDkgMTYuNTQ5NiA5IDE1Ljk5OTZDOSAxNS40NDk2IDkuNDUgMTQuOTk5NiAxMCAxNC45OTk2SDEzTDE1LjYgMTAuNTk5NkgxNi43TDE1LjQgMTQuOTk5NkgxOC4yNUwxOSAxMy45OTk2SDIwTDE5LjQgMTUuOTk5NkwyMCAxNy45OTk2SDE5TDE4LjI1IDE2Ljk5OTZIMTUuNFpNNS43NSA2Ljk5OTYxTDUgNS45OTk2MUg0TDQuNiA3Ljk5OTYxTDQgOS45OTk2MUg1TDUuNzUgOC45OTk2MUg4LjZMNy4zIDEzLjM5OTZIOC40TDExIDguOTk5NjFIMTRDMTQuNTUgOC45OTk2MSAxNSA4LjU0OTYxIDE1IDcuOTk5NjFDMTUgNy40NDk2MSAxNC41NSA2Ljk5OTYxIDE0IDYuOTk5NjFIMTFMOC40IDIuNTk5NjFINy4zTDguNiA2Ljk5OTYxSDUuNzVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ConnectingAirports = createIcon('ConnectingAirports', [
  [
    'path',
    {
      d: 'M15.4 16.9996L16.7 21.3996H15.6L13 16.9996H10C9.45 16.9996 9 16.5496 9 15.9996C9 15.4496 9.45 14.9996 10 14.9996H13L15.6 10.5996H16.7L15.4 14.9996H18.25L19 13.9996H20L19.4 15.9996L20 17.9996H19L18.25 16.9996H15.4ZM5.75 6.99961L5 5.99961H4L4.6 7.99961L4 9.99961H5L5.75 8.99961H8.6L7.3 13.3996H8.4L11 8.99961H14C14.55 8.99961 15 8.54961 15 7.99961C15 7.44961 14.55 6.99961 14 6.99961H11L8.4 2.59961H7.3L8.6 6.99961H5.75Z',
      key: 'cy8wh7',
    },
  ],
]);

export default ConnectingAirports;
